import type { ClassificacaoEscopo } from "@/modules/financeiro-obras";
import { NO_VALUE, UNIDADE_MILHOES } from "./planejamento-controle.constants";

const MILHAO = 1_000_000;
const MIL = 1_000;
const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

function numero(valor: number, casas: number): string {
  return valor.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

/** Cards e tabela: R$ milhões com 1 casa com 1 casa; a redução é só de exibição. */
export function formatMilhoes(valor: number | null | undefined): string {
  return typeof valor === "number" ? numero(valor / MILHAO, 1) : NO_VALUE;
}

export function formatMil(valor: number | null | undefined): string {
  return typeof valor === "number" ? numero(valor / MIL, 1) : NO_VALUE;
}

export function formatMilhoesComUnidade(valor: number | null | undefined): string {
  if (typeof valor !== "number") return NO_VALUE;
  return `${UNIDADE_MILHOES.simbolo} ${formatMilhoes(valor)} ${UNIDADE_MILHOES.sufixo}`;
}

/** Percentual sem casas decimais. */
export function formatPercentual(valor: number | null | undefined): string {
  return typeof valor === "number" ? `${Math.round(valor)}%` : NO_VALUE;
}

/** Detalhe do escopo: R$ com 2 casas, sem o símbolo (o cabeçalho da coluna diz "Total (R$)"). */
export function formatReaisSimples(valor: number | null | undefined): string {
  return typeof valor === "number" ? numero(valor, 2) : NO_VALUE;
}

const SIMBOLOS: Record<string, string> = { BRL: "R$", USD: "US$", EUR: "€" };

export function formatMoeda(valor: number, moeda: string): string {
  return `${SIMBOLOS[moeda] ?? moeda} ${numero(valor, 2)}`;
}

export function rotuloObra(codigo: string, nome?: string | null): string {
  const nomeLimpo = nome?.trim();
  return nomeLimpo ? `Obra ${codigo} · ${nomeLimpo}` : `Obra ${codigo}`;
}

/** `2027-03` → `mar/27`; ISO de data (`2027-03-15`) também. */
export function formatCompetencia(iso: string | null | undefined): string {
  const partes = /^(\d{4})-(\d{2})/.exec(iso ?? "");
  if (!partes) return NO_VALUE;
  const [, ano = "", mes = ""] = partes;
  return `${MESES[Number(mes) - 1] ?? mes}/${ano.slice(2)}`;
}

/** Variação com até 1 casa, com sinal: `-10%`, `+9,1%`. */
export function formatVariacao(percentual: number): string {
  const texto = percentual.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
  return `${percentual > 0 ? "+" : ""}${texto}%`;
}

const CLASSIFICACAO: Record<ClassificacaoEscopo, string> = {
  CAPEX: "CAPEX",
  OPEX: "OPEX",
  PENDENTE: "Pendente",
  NAO_SE_APLICA: NO_VALUE,
};

export function formatClassificacao(classificacao: ClassificacaoEscopo): string {
  return CLASSIFICACAO[classificacao];
}

export const formatTaxa = (valor: number) =>
  `R$ ${valor.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 6 })}`;
